import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TenantContextService } from "../services/tenant-context.service";

/**
 * Super-admin route guard. Fixes a race where navigation to /super/*
 * happened before TenantContextService.load() resolved — isSuperAdmin()
 * returned false and every super-admin click bounced to /home on the
 * first navigation after login / page refresh.
 *
 * Now: the guard is async. If memberships haven't loaded yet, await
 * the load before deciding.
 */
export const SuperAdminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const tenantContext = inject(TenantContextService);

  if (tenantContext.memberships().length === 0 && !tenantContext.active()) {
    try {
      await tenantContext.load();
    } catch {
      /* fall through to deny below */
    }
  }

  if (tenantContext.isSuperAdmin()) return true;

  router.navigateByUrl("/home");
  return false;
};
